export const ROUTE_PATH = '/stores/:storeId/receipts';

export const FEATURE_NAME = 'storeReceiptsPage';
